@if (loaded()) {
<forge-card class="pad-card">
    <forge-toolbar>
        <h2 slot="start" class="forge-typography--heading4">Email Test</h2>
    </forge-toolbar>

    <form #form="ngForm">
        <metadata-panel ngModelGroup="emailTest" [metadata]="metadata()!" [model]="model()!" [viewOnly]="true">
        </metadata-panel>
    </form>

    <div fxLayout="row" fxLayoutAlign="flex-end flex-end">
        <forge-button variant="outlined" (click)="test()" [disabled]="running">
            Test
        </forge-button>
    </div>
</forge-card>
}